import Marquee from "react-fast-marquee";

const ITEMS = [
  "EVERY MILE MEANS SOMETHING",
  "HOPE RESTORED MISSIONS",
  "5K TIMED RUN",
  "1 MILE FUN WALK",
  "NOV 21 · ALLEN, TEXAS",
];

export const MarqueeRibbon = () => (
  <div data-testid="marquee-ribbon" className="overflow-hidden border-y border-black/10 bg-hope-green py-5">
    <Marquee speed={35} gradient={false}>
      {ITEMS.map((item) => (
        <span key={item} className="mx-6 flex items-center gap-12 font-heading text-lg font-bold uppercase tracking-[0.15em] text-white md:text-xl">
          {item}
          <span className="ml-10 inline-block h-2.5 w-2.5 rounded-full bg-hope-red" />
        </span>
      ))}
    </Marquee>
  </div>
);
